import { require_jsx_runtime as e } from "./index21.js";
//#region src/components/Common/GoogleTagManager.tsx
var t = e(), n = ({ isEnabled: e, tagId: n, url: r }) => {
	if (e) return null;
	window.dataLayer = window.dataLayer || [];
	function i(...e) {
		dataLayer.push(e);
	}
	return i("js", /* @__PURE__ */ new Date()), i("config", n), /* @__PURE__ */ (0, t.jsx)("script", {
		async: !0,
		src: r
	});
};
//#endregion
export { n as GoogleTagManager };

//# sourceMappingURL=index557.js.map